"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { selected: [] };
    },
    onSelect: function (schedule, e) {
        e.target.checked ? this.state.selected.push(schedule) : this.state.selected = this.state.selected.filter(each => {
            return JSON.stringify(each) != JSON.stringify(schedule);
        });
        this.setStateDirty('selected');
        this.emit('select', this.state.selected);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Preview/components/ChooseDate.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_attrs0 = {
        "class": "schedule-list"
      },
    marko_attrs1 = {
        "class": "font-medium-5"
      },
    marko_attrs2 = {
        "class": "py-50"
      },
    marko_attrs3 = {
        "class": "checkbox checkbox-secondary checkbox-lg"
      },
    marko_attrs4 = {
        "class": "px-50"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.be("h5", marko_attrs1, "1", component);

  Locale_tag({
      text: "Scheduled for"
    }, out, __component, "2");

  out.ee();

  var $for$0 = 0;

  marko_forOf(input.list, function(schedule, index) {
    const { start, end } = schedule

    const isSelected = state.selected.length && state.selected.filter( each => { return JSON.stringify( each ) == JSON.stringify( schedule ) } ).length

    var $keyScope$0 = "[" + (($for$0++) + "]");

    out.be("div", marko_attrs2, "3" + $keyScope$0, component);

    out.be("div", marko_attrs3, "4" + $keyScope$0, component);

    out.e("input", {
        type: "checkbox",
        id: "schedule-" + index,
        checked: isSelected ? true : false
      }, "5" + $keyScope$0, component, 0, 0, {
        onchange: __component.d("change", "onSelect", false, [
            schedule
          ])
      });

    out.be("label", {
        "for": "schedule-" + index,
        "class": "font-medium-1"
      }, "6" + $keyScope$0, component);

    if (start && (!isEmpty(start))) {
      out.e("span", null, "7" + $keyScope$0, component, 1)
        .t(start.date + (start.time ? " " + start.time : ""), component);
    }

    if (end && (!isEmpty(end))) {
      out.e("span", null, "8" + $keyScope$0, component, 2)
        .e("span", marko_attrs4, "9" + $keyScope$0, component, 1)
          .t("-")
        .t(end.date + (end.time ? " " + end.time : ""), component);
    }

    out.ee();

    out.ee();

    out.ee();
  });

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
